import { Container, Nav, Navbar } from 'react-bootstrap'
import './StepHeader.scss'

export const StepHeader = () => {
  return (
    <Navbar bg="light" expand="lg">
      <Container>
        <Navbar.Brand href="/">
          <div className="d-flex align-items-center logo-container">
            <img
              className="d-inline-block me-3"
              alt="Marketo Integrator logo"
              src="/cs-logo-icon@2x.png"
              style={{
                height: '3.5rem',
              }}
            />
            <div className="d-inline-flex flex-column">
              <h3
                className="d-inline-block m-0 logo-container__header"
                style={{
                  lineHeight: '1.4rem',
                }}
              >
                <b>Workfront Migration Utility</b>
              </h3>
              <span
                style={{
                  lineHeight: '1.4rem',
                }}
                className="logo-container__subheader"
              >
                By CapabilitySource
              </span>
            </div>
          </div>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse className="justify-content-end">
          <Nav>
            <Nav.Link href="/">About</Nav.Link>
            <Nav.Link href="/">Contact Us</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  )
}
